import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/shared/hooks';

type SearchInputProps = {
	searchTerm: string;
	setSearchTerm: (value: string) => void;
};

const SearchInput = ({ searchTerm, setSearchTerm }: SearchInputProps) => {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	return (
		<input
			type='text'
			placeholder={t('form_placeholders.search')}
			className='w-full py-2 px-4 border-b outline-none'
			value={searchTerm}
			onChange={(e) => setSearchTerm(e.target.value)}
			autoFocus={!isMobile}
		/>
	);
};

export default SearchInput;
